var _path, _circle, _g, _path2, _path3, _path4, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 112,
    viewBox: "0 0 129 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.645 23.2865C111.316 23.6435 118.997 22.4604 120.343 14.8718C121.69 7.28321 125.29 5.18208 126.922 5.08008",
    stroke: "#00B327",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75.037,
    cy: 54.2402,
    r: 36.7118,
    fill: "#EF4949"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_945_201)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 75.0371,
    cy: 54.2403,
    r: 31.0996,
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 2
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3514 46.2084C91.3514 47.208 90.9591 48.1732 90.2459 48.8626L73.6641 64.9255C72.9153 65.6149 71.9168 66.0285 70.8827 66.0285C69.8485 66.0285 68.85 65.6149 68.1368 64.9255L59.8281 56.894C59.1149 56.2046 58.7227 55.2395 58.7227 54.2398C58.7227 53.2402 59.1506 52.3095 59.8638 51.5857C60.6126 50.8963 61.5754 50.5171 62.6096 50.4826C63.6437 50.4826 64.6065 50.8618 65.3554 51.5512L70.8827 56.894L84.7187 43.5197C85.4675 42.8303 86.4303 42.4512 87.4645 42.4512C88.4986 42.4856 89.4614 42.8648 90.2103 43.5887C90.9235 44.2781 91.3514 45.2088 91.3514 46.2084Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.524 90.9521C105.952 91.9422 112.578 95.7043 111.664 102.833",
    stroke: "#F7B23B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 80.8924C7.25926 82.8732 18.5974 84.2939 21.876 74.1305M21.876 74.1305C22.3541 71.3301 21.876 65.7908 16.1387 66.0367C15.0458 68.7347 14.6632 74.1305 21.876 74.1305ZM21.876 74.1305C24.2666 74.5745 29.8264 74.151 32.941 68.9054",
    stroke: "#00B327",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.4603,
    cy: 108.046,
    r: 3.51891,
    fill: "#00B327"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.726,
    cy: 52.3221,
    r: 3.01891,
    stroke: "#00B327"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.8672,
    cy: 3.8535,
    r: 3.8535,
    fill: "#00B327"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.8085,
    cy: 10.3578,
    r: 2.03507,
    fill: "#00B327"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.9541,
    cy: 40.2447,
    r: 3.06644,
    stroke: "#F7B23B"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.1462,
    cy: 96.4807,
    r: 3.42158,
    stroke: "#EF4949"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.87349,
    cy: 1.87349,
    r: 1.87349,
    transform: "matrix(-1 0 0 1 76.3926 102.137)",
    fill: "#EF4949"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_945_201",
    x: 38.9375,
    y: 21.1406,
    width: 72.1992,
    height: 72.1992,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_945_201"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_945_201",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.e4ebca2b81a3c9adabe23254e1778dda.svg";
export { ForwardRef as ReactComponent };